// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ScenarioTabs/ScenarioTabs.css */
/* Clean light tab bar with prominent active tab and visible buttons */

.scenario-tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* ============ TABS BAR - LIGHT THEME ============ */
.tabs-bar {
  display: flex;
  align-items: stretch;
  height: 50px;
  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  padding: 0;
  position: relative;
}

/* ============ SCROLL ARROWS ============ */
.scroll-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease;
  color: #64748b;
  z-index: 10;
}

.scroll-arrow svg {
  width: 18px;
  height: 18px;
}

.scroll-arrow.visible {
  opacity: 1;
  pointer-events: auto;
}

.scroll-arrow:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.scroll-arrow:active {
  background: #e2e8f0;
}

/* ============ TABS SCROLL CONTAINER ============ */
.tabs-scroll-container {
  flex: 1 1;
  min-width: 0;
  position: relative;
  overflow: hidden;
}

/* Gradient fade indicators */
.tabs-scroll-container::before,
.tabs-scroll-container::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px;
  pointer-events: none;
  z-index: 5;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tabs-scroll-container::before {
  left: 0;
  background: linear-gradient(90deg, #f1f5f9 0%, transparent 100%);
}

.tabs-scroll-container::after {
  right: 0;
  background: linear-gradient(-90deg, #f1f5f9 0%, transparent 100%);
}

.tabs-scroll-container.has-left::before {
  opacity: 1;
}

.tabs-scroll-container.has-right::after {
  opacity: 1;
}

/* ============ TABS SCROLL ============ */
.tabs-scroll {
  display: flex;
  align-items: flex-end;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding: 8px 8px 0;
  gap: 6px;

  /* Hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tabs-scroll::-webkit-scrollbar {
  display: none;
}

/* ============ TAB - VISIBLE & CLEAR ============ */
.tab {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 42px;
  padding: 0 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  flex-shrink: 0;
  min-width: 120px;
  max-width: 200px;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
}

.tab:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* ============ ACTIVE TAB - VERY PROMINENT ============ */
.tab.active {
  background: #ffffff;
  border-color: #3b82f6;
  border-width: 2px;
  border-bottom: none;
  box-shadow:
    0 -4px 16px rgba(59, 130, 246, 0.25),
    0 -1px 4px rgba(59, 130, 246, 0.15);
  z-index: 10;
  margin-bottom: -1px;
  padding-bottom: 1px;
}

/* Blue accent bar on active tab */
.tab.active::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  border-radius: 10px 10px 0 0;
}

/* Tab index number */
.tab-index {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.tab.active .tab-index {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.4);
}

/* Tab label */
.tab-label {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab.active .tab-label {
  color: #1e293b;
  font-weight: 600;
}

/* Tab name input */
.tab-name-input {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 8px;
  border: 2px solid #3b82f6;
  border-radius: 6px;
  outline: none;
  background: #ffffff;
}

.tab-name-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

/* Tab close button */
.tab-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #94a3b8;
  opacity: 0;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.tab-close svg {
  width: 14px;
  height: 14px;
}

.tab:hover .tab-close,
.tab.active .tab-close {
  opacity: 1;
}

.tab-close:hover {
  background: #fee2e2;
  color: #dc2626;
}

/* ============ ACTIONS CONTAINER ============ */
.tabs-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  border-left: 1px solid #e2e8f0;
  background: #f8fafc;
}

/* User menu in header */
.user-menu {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 8px;
  padding-left: 12px;
  border-left: 1px solid #e2e8f0;
}

.user-menu-name {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu .action-btn.users-btn,
.user-menu .action-btn.logout-btn {
  padding: 0 8px;
  height: 32px;
  background: transparent;
  color: #94A3B8;
}

.user-menu .action-btn.users-btn:hover {
  color: #F59E0B;
  background: #FFFBEB;
}

.user-menu .action-btn.logout-btn:hover {
  color: #EF4444;
  background: #FEF2F2;
}

.user-menu .action-btn svg {
  width: 16px;
  height: 16px;
}

/* ============ ACTION BUTTONS ============ */
.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.action-btn svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* New button - BLUE & VISIBLE */
.action-btn.new-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.35);
}

.action-btn.new-btn:hover {
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.45);
  transform: translateY(-1px);
}

.action-btn.new-btn:active {
  transform: translateY(0);
}

/* Save button - GREEN */
.action-btn.save-btn {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.35);
}

.action-btn.save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #4ade80, #22c55e);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.45);
  transform: translateY(-1px);
}

.action-btn.save-btn:active:not(:disabled) {
  transform: translateY(0);
}

.action-btn.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Save button states */
.action-btn.save-btn.saving {
  background: #94a3b8;
  box-shadow: none;
  animation: savePulse 1s ease-in-out infinite;
}

@keyframes savePulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.action-btn.save-btn.success {
  background: linear-gradient(135deg, #10b981, #059669);
  animation: saveSuccess 0.4s ease-out;
}

@keyframes saveSuccess {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(16, 185, 129, 0.5); }
  100% { transform: scale(1); }
}

.action-btn.save-btn.has-changes {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35);
  animation: hasChanges 2s ease-in-out infinite;
}

@keyframes hasChanges {
  0%, 100% { box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35); }
  50% { box-shadow: 0 4px 16px rgba(245, 158, 11, 0.6); }
}

/* ============ SCENARIO CONTENT ============ */
.scenario-content {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  background: #ffffff;
}

/* ============ SCENARIO NAVIGATION CONTROLS ============ */
.scenario-nav-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-right: 1px solid #e2e8f0;
}

/* Scenario counter */
.scenario-counter {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

/* Scenario selector dropdown */
.scenario-selector {
  position: relative;
}

.scenario-selector-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.15s ease;
}

.scenario-selector-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #475569;
}

.scenario-selector-btn svg {
  width: 16px;
  height: 16px;
}

.scenario-selector-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  width: 280px;
  max-height: 400px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.scenario-selector-search {
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
  outline: none;
  border-radius: 8px 8px 0 0;
}

.scenario-selector-search::placeholder {
  color: #94a3b8;
}

.scenario-selector-list {
  overflow-y: auto;
  max-height: 340px;
  padding: 4px;
}

.scenario-selector-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.1s ease;
}

.scenario-selector-item:hover {
  background: #f1f5f9;
}

.scenario-selector-item.active {
  background: #dbeafe;
}

.scenario-selector-item.latest .item-name {
  font-weight: 600;
}

.scenario-selector-item .item-index {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #e2e8f0;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  flex-shrink: 0;
}

.scenario-selector-item.active .item-index {
  background: #3b82f6;
  color: white;
}

.scenario-selector-item .item-name {
  flex: 1 1;
  font-size: 13px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scenario-selector-item .item-badge {
  font-size: 10px;
  font-weight: 600;
  color: #059669;
  background: #d1fae5;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

.scenario-selector-empty {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

/* Jump to latest button */
.jump-to-latest-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #dbeafe;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  cursor: pointer;
  color: #2563eb;
  transition: all 0.15s ease;
}

.jump-to-latest-btn:hover {
  background: #bfdbfe;
  border-color: #60a5fa;
}

.jump-to-latest-btn svg {
  width: 16px;
  height: 16px;
}

/* ============ RESPONSIVE ============ */
@media (max-width: 900px) {
  .action-btn span {
    display: none;
  }

  .action-btn {
    padding: 0 12px;
    width: 36px;
    justify-content: center;
  }

  .tab {
    min-width: 100px;
    padding: 0 12px;
  }

  .scenario-nav-controls {
    gap: 6px;
    padding: 0 8px;
  }

  .scenario-selector-dropdown {
    width: 250px;
    left: -50px;
  }
}

@media (max-width: 600px) {
  .tabs-bar {
    height: 46px;
  }

  .tabs-scroll {
    padding: 6px 6px 0;
  }

  .tab {
    height: 38px;
    min-width: 80px;
    padding: 0 10px;
    gap: 8px;
  }

  .tab-index {
    width: 20px;
    height: 20px;
    font-size: 11px;
  }

  .tab-label {
    font-size: 13px;
  }

  .tabs-actions {
    padding: 0 10px;
    gap: 8px;
  }

  .action-btn {
    height: 32px;
    width: 32px;
    padding: 0 10px;
  }

  .action-btn svg {
    width: 16px;
    height: 16px;
  }

  .scenario-nav-controls {
    gap: 4px;
    padding: 0 6px;
  }

  .scenario-counter {
    font-size: 11px;
    padding: 3px 6px;
  }

  .scenario-selector-btn,
  .jump-to-latest-btn {
    width: 28px;
    height: 28px;
  }

  .scenario-selector-btn svg,
  .jump-to-latest-btn svg {
    width: 14px;
    height: 14px;
  }

  .scenario-selector-dropdown {
    width: 220px;
    left: -80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScenarioTabs/ScenarioTabs.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD,sEAAsE;;AAEtE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;EAC7D,gCAAgC;EAChC,UAAU;EACV,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,gEAAgE;AAClE;;AAEA;EACE,QAAQ;EACR,iEAAiE;AACnE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;;EAER,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB;;uCAEqC;EACrC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,qDAAqD;EACrD,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,qDAAqD;EACrD,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE,4CAA4C,EAAE;EAC5E,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,WAAW,8CAA8C,EAAE;EAC3D,MAAM,8CAA8C,EAAE;AACxD;;AAEA,+CAA+C;AAC/C;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":["/* src/components/ScenarioTabs/ScenarioTabs.css */\n/* Clean light tab bar with prominent active tab and visible buttons */\n\n.scenario-tabs {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* ============ TABS BAR - LIGHT THEME ============ */\n.tabs-bar {\n  display: flex;\n  align-items: stretch;\n  height: 50px;\n  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);\n  border-bottom: 1px solid #e2e8f0;\n  padding: 0;\n  position: relative;\n}\n\n/* ============ SCROLL ARROWS ============ */\n.scroll-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  min-width: 32px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  color: #64748b;\n  z-index: 10;\n}\n\n.scroll-arrow svg {\n  width: 18px;\n  height: 18px;\n}\n\n.scroll-arrow.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.scroll-arrow:hover {\n  background: #f1f5f9;\n  color: #1e293b;\n}\n\n.scroll-arrow:active {\n  background: #e2e8f0;\n}\n\n/* ============ TABS SCROLL CONTAINER ============ */\n.tabs-scroll-container {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Gradient fade indicators */\n.tabs-scroll-container::before,\n.tabs-scroll-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 40px;\n  pointer-events: none;\n  z-index: 5;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.tabs-scroll-container::before {\n  left: 0;\n  background: linear-gradient(90deg, #f1f5f9 0%, transparent 100%);\n}\n\n.tabs-scroll-container::after {\n  right: 0;\n  background: linear-gradient(-90deg, #f1f5f9 0%, transparent 100%);\n}\n\n.tabs-scroll-container.has-left::before {\n  opacity: 1;\n}\n\n.tabs-scroll-container.has-right::after {\n  opacity: 1;\n}\n\n/* ============ TABS SCROLL ============ */\n.tabs-scroll {\n  display: flex;\n  align-items: flex-end;\n  height: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-behavior: smooth;\n  padding: 8px 8px 0;\n  gap: 6px;\n\n  /* Hide scrollbar */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tabs-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n/* ============ TAB - VISIBLE & CLEAR ============ */\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 42px;\n  padding: 0 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-bottom: none;\n  border-radius: 10px 10px 0 0;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n  flex-shrink: 0;\n  min-width: 120px;\n  max-width: 200px;\n  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.tab:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* ============ ACTIVE TAB - VERY PROMINENT ============ */\n.tab.active {\n  background: #ffffff;\n  border-color: #3b82f6;\n  border-width: 2px;\n  border-bottom: none;\n  box-shadow:\n    0 -4px 16px rgba(59, 130, 246, 0.25),\n    0 -1px 4px rgba(59, 130, 246, 0.15);\n  z-index: 10;\n  margin-bottom: -1px;\n  padding-bottom: 1px;\n}\n\n/* Blue accent bar on active tab */\n.tab.active::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6, #60a5fa);\n  border-radius: 10px 10px 0 0;\n}\n\n/* Tab index number */\n.tab-index {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #f1f5f9;\n  color: #64748b;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.tab.active .tab-index {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.4);\n}\n\n/* Tab label */\n.tab-label {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tab.active .tab-label {\n  color: #1e293b;\n  font-weight: 600;\n}\n\n/* Tab name input */\n.tab-name-input {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border: 2px solid #3b82f6;\n  border-radius: 6px;\n  outline: none;\n  background: #ffffff;\n}\n\n.tab-name-input:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n/* Tab close button */\n.tab-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #94a3b8;\n  opacity: 0;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.tab-close svg {\n  width: 14px;\n  height: 14px;\n}\n\n.tab:hover .tab-close,\n.tab.active .tab-close {\n  opacity: 1;\n}\n\n.tab-close:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* ============ ACTIONS CONTAINER ============ */\n.tabs-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 16px;\n  border-left: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n/* User menu in header */\n.user-menu {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 8px;\n  padding-left: 12px;\n  border-left: 1px solid #e2e8f0;\n}\n\n.user-menu-name {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu .action-btn.users-btn,\n.user-menu .action-btn.logout-btn {\n  padding: 0 8px;\n  height: 32px;\n  background: transparent;\n  color: #94A3B8;\n}\n\n.user-menu .action-btn.users-btn:hover {\n  color: #F59E0B;\n  background: #FFFBEB;\n}\n\n.user-menu .action-btn.logout-btn:hover {\n  color: #EF4444;\n  background: #FEF2F2;\n}\n\n.user-menu .action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ============ ACTION BUTTONS ============ */\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.action-btn svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* New button - BLUE & VISIBLE */\n.action-btn.new-btn {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.35);\n}\n\n.action-btn.new-btn:hover {\n  background: linear-gradient(135deg, #60a5fa, #3b82f6);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.45);\n  transform: translateY(-1px);\n}\n\n.action-btn.new-btn:active {\n  transform: translateY(0);\n}\n\n/* Save button - GREEN */\n.action-btn.save-btn {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.35);\n}\n\n.action-btn.save-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #4ade80, #22c55e);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.45);\n  transform: translateY(-1px);\n}\n\n.action-btn.save-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.action-btn.save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Save button states */\n.action-btn.save-btn.saving {\n  background: #94a3b8;\n  box-shadow: none;\n  animation: savePulse 1s ease-in-out infinite;\n}\n\n@keyframes savePulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n.action-btn.save-btn.success {\n  background: linear-gradient(135deg, #10b981, #059669);\n  animation: saveSuccess 0.4s ease-out;\n}\n\n@keyframes saveSuccess {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(16, 185, 129, 0.5); }\n  100% { transform: scale(1); }\n}\n\n.action-btn.save-btn.has-changes {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35);\n  animation: hasChanges 2s ease-in-out infinite;\n}\n\n@keyframes hasChanges {\n  0%, 100% { box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35); }\n  50% { box-shadow: 0 4px 16px rgba(245, 158, 11, 0.6); }\n}\n\n/* ============ SCENARIO CONTENT ============ */\n.scenario-content {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  background: #ffffff;\n}\n\n/* ============ SCENARIO NAVIGATION CONTROLS ============ */\n.scenario-nav-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border-right: 1px solid #e2e8f0;\n}\n\n/* Scenario counter */\n.scenario-counter {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n/* Scenario selector dropdown */\n.scenario-selector {\n  position: relative;\n}\n\n.scenario-selector-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #64748b;\n  transition: all 0.15s ease;\n}\n\n.scenario-selector-btn:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #475569;\n}\n\n.scenario-selector-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.scenario-selector-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  width: 280px;\n  max-height: 400px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n}\n\n.scenario-selector-search {\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 14px;\n  outline: none;\n  border-radius: 8px 8px 0 0;\n}\n\n.scenario-selector-search::placeholder {\n  color: #94a3b8;\n}\n\n.scenario-selector-list {\n  overflow-y: auto;\n  max-height: 340px;\n  padding: 4px;\n}\n\n.scenario-selector-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.1s ease;\n}\n\n.scenario-selector-item:hover {\n  background: #f1f5f9;\n}\n\n.scenario-selector-item.active {\n  background: #dbeafe;\n}\n\n.scenario-selector-item.latest .item-name {\n  font-weight: 600;\n}\n\n.scenario-selector-item .item-index {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.scenario-selector-item.active .item-index {\n  background: #3b82f6;\n  color: white;\n}\n\n.scenario-selector-item .item-name {\n  flex: 1;\n  font-size: 13px;\n  color: #334155;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scenario-selector-item .item-badge {\n  font-size: 10px;\n  font-weight: 600;\n  color: #059669;\n  background: #d1fae5;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.scenario-selector-empty {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n/* Jump to latest button */\n.jump-to-latest-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #dbeafe;\n  border: 1px solid #93c5fd;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #2563eb;\n  transition: all 0.15s ease;\n}\n\n.jump-to-latest-btn:hover {\n  background: #bfdbfe;\n  border-color: #60a5fa;\n}\n\n.jump-to-latest-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ============ RESPONSIVE ============ */\n@media (max-width: 900px) {\n  .action-btn span {\n    display: none;\n  }\n\n  .action-btn {\n    padding: 0 12px;\n    width: 36px;\n    justify-content: center;\n  }\n\n  .tab {\n    min-width: 100px;\n    padding: 0 12px;\n  }\n\n  .scenario-nav-controls {\n    gap: 6px;\n    padding: 0 8px;\n  }\n\n  .scenario-selector-dropdown {\n    width: 250px;\n    left: -50px;\n  }\n}\n\n@media (max-width: 600px) {\n  .tabs-bar {\n    height: 46px;\n  }\n\n  .tabs-scroll {\n    padding: 6px 6px 0;\n  }\n\n  .tab {\n    height: 38px;\n    min-width: 80px;\n    padding: 0 10px;\n    gap: 8px;\n  }\n\n  .tab-index {\n    width: 20px;\n    height: 20px;\n    font-size: 11px;\n  }\n\n  .tab-label {\n    font-size: 13px;\n  }\n\n  .tabs-actions {\n    padding: 0 10px;\n    gap: 8px;\n  }\n\n  .action-btn {\n    height: 32px;\n    width: 32px;\n    padding: 0 10px;\n  }\n\n  .action-btn svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .scenario-nav-controls {\n    gap: 4px;\n    padding: 0 6px;\n  }\n\n  .scenario-counter {\n    font-size: 11px;\n    padding: 3px 6px;\n  }\n\n  .scenario-selector-btn,\n  .jump-to-latest-btn {\n    width: 28px;\n    height: 28px;\n  }\n\n  .scenario-selector-btn svg,\n  .jump-to-latest-btn svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .scenario-selector-dropdown {\n    width: 220px;\n    left: -80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
